import Image from "next/image";
import { cdnBaseURL } from '@/commons/constants';

const ImageBox = ({ slug, name, onClick, imageUrl }) => {
  return (
    <div
      className="group flex justify-center relative border bg-white border-slot-book rounded-lg cursor-pointer transition-transform duration-200 hover:scale-[1.02]"
      onClick={() => onClick(slug)}
    >
      <div className="relative w-[204px] h-[236px] sm:w-[224px] sm:h-[256px] md:w-[280px] md:h-[280px] lg:w-[360px] lg:h-[360px] overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-shadow duration-300 ease-in-out">
        {/* Main Image */}
        <Image
          src={imageUrl?.replace("bmpassets.s3.ap-south-1.amazonaws.com",cdnBaseURL)}
          alt={name}
          fill
          sizes="(max-width: 640px) 204px, (max-width: 768px) 224px, (max-width: 1024px) 280px, 360px"
          className="object-cover"
          priority={false}
        />

        {/* Text Overlay */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent p-3 sm:p-4 md:p-5">
          <span className="flex items-center justify-center text-white font-semibold text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-center leading-tight">
            {name?.slice(0, 30).replace(/-/g, " ") +
              (name?.length > 30 ? "..." : "")}
          </span>
        </div>

        {/* Decorative Corner Icon */}
        <div className="absolute  sm:-top-3 sm:-left-3 w-12 h-12 sm:w-14 sm:h-14 md:w-20 md:h-20 lg:w-24 lg:h-24 z-10 group-hover:[animation-play-state:paused]" style={{ animation: 'moveAndRotate 4s ease-in-out infinite' }}>
          <Image
            src="/icons/Group6334.svg"
            alt="Decorative rangoli"
            fill
            className="object-contain"
            priority={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageBox;